import React from 'react';

import { propsArrowLineBackground } from '../const';

const MIN_DISTANCE_ARROW = 10;

export interface IGantGridArrowRaw {
    pointStart: { x: number; y: number };
    pointEnd: { x: number; y: number };
    propsArrowLine: React.SVGLineElementAttributes<SVGLineElement>;
}

const GantGridArrowSS: React.FC<IGantGridArrowRaw> = ({ pointStart, pointEnd, propsArrowLine }) => {
    const minX = Math.min(pointStart.x, pointEnd.x) - MIN_DISTANCE_ARROW;

    const renderLine = (propsLine: React.SVGLineElementAttributes<SVGLineElement>) => (
        <>
            <line x1={pointStart.x} y1={pointStart.y} x2={minX} y2={pointStart.y} {...propsLine} />;
            <line x1={minX} y1={pointStart.y} x2={minX} y2={pointEnd.y} {...propsLine} />;
            <line x1={minX} y1={pointEnd.y} x2={pointEnd.x} y2={pointEnd.y} {...propsLine} />;
        </>
    );

    return (
        <>
            {renderLine(propsArrowLine)}
            {renderLine(propsArrowLineBackground)}
        </>
    );
};

export default React.memo(GantGridArrowSS);
